<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
body{
	position: relative;
	margin: 0;
	padding: 0;
	overflow: auto !important;
}

</style>



// WEBPACK FOOTER //
// App.vue?e6740a04